import { IS_BROWSER } from "./browserUtils";

class MemoryStorage {
  private readonly storage: Map<string, string>;

  constructor() {
    this.storage = new Map();
  }

  public getItem(key: string): string | null {
    return this.storage.get(key) || null;
  }
  public setItem(key: string, value: string): void {
    this.storage.set(key, value);
  }
  public removeItem(key: string): void {
    this.storage.delete(key);
  }
}

export class AppStorage {
  private readonly storage: Storage | MemoryStorage;

  constructor(storage: Storage | MemoryStorage) {
    this.storage = storage;
  }

  public getBoolean(key: string, defaultValue: boolean): boolean {
    if (this.storage.getItem(key) === null) return defaultValue;
    return this.storage.getItem(key) === "true";
  }

  public getNumber(key: string, defaultValue: number): number {
    return Number(this.storage.getItem(key) || defaultValue);
  }

  public getString(key: string, defaultValue: string): string {
    return this.storage.getItem(key) || defaultValue;
  }

  public getObject<T = any>(key: string, defaultValue: T | null = null): T | null {
    let data: T | null;
    const rowData = this.storage.getItem(key);
    try {
      data = rowData ? JSON.parse(rowData) : defaultValue;
    } catch (e) {
      data = defaultValue;
    }
    return data;
  }

  public setBoolean(key: string, value: boolean): void {
    this.storage.setItem(key, value.toString());
  }

  public setNumber(key: string, value: number): void {
    this.storage.setItem(key, value.toString());
  }

  public setString(key: string, value: string): void {
    this.storage.setItem(key, value);
  }

  public setObject(key: string, value: any): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  public getKeys(): string[] {
    return Object.keys(this.storage);
  }
  public remove(key: string): void {
    this.storage.removeItem(key);
  }
}

export default new AppStorage(IS_BROWSER ? localStorage : new MemoryStorage());
export const AppSessionStorage = new AppStorage(IS_BROWSER ? sessionStorage : new MemoryStorage());
